import actionTypes from './index';

export default excludedEstimateId => ({
  type: actionTypes.INIT_STORE,
  payload: { designId: excludedEstimateId },
});
